import { Flex, IconButton } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronRight, faQuestion } from '@fortawesome/pro-regular-svg-icons';
import { useDispatch } from 'react-redux';
import { createNavigateToAction } from '../../../middleware/actions';

export enum SectionStatus {
  complete,
  incomplete,
  todo,
  empty,
  skipped
}
interface IProps {
  section1: SectionStatus;
  section2: SectionStatus;
  section3: SectionStatus;
  section4: SectionStatus;
}

interface IButtonProps {
  status: SectionStatus;
  navigateToURL: string;
  title: string;
}

const getButtonProps = (status: SectionStatus) => {
  switch (status) {
    case SectionStatus.complete:
      return {
        colorScheme: 'gray',
        icon: <FontAwesomeIcon icon={faCheck} size="lg" title="Section complete" />
      };
    case SectionStatus.incomplete:
      return {
        colorScheme: 'orange',
        icon: <FontAwesomeIcon icon={faQuestion} size="lg" title="Section incomplete" />
      };
    case SectionStatus.todo:
      return {
        colorScheme: 'blue',
        icon: <FontAwesomeIcon icon={faChevronRight} size="lg" title="Section to do" />
      };
    case SectionStatus.empty:
      return {
        colorScheme: 'gray',
        isDisabled: true,
        icon: undefined
      };
    default:
      return null;
  }
};

const SectionSummary = (props: IProps) => {
  const { section1, section2, section3, section4 } = props;
  const dispatch = useDispatch();
  const onNavigateTo = (url: string) => dispatch(createNavigateToAction(url));

  const renderSectionIconButton = ({ status, title, navigateToURL }: IButtonProps) => {
    return (
      <IconButton
        aria-label={title}
        title={title}
        onClick={() => onNavigateTo(navigateToURL)}
        size="sm"
        variant="solid"
        borderRadius="full"
        {...getButtonProps(status)}
        pointerEvents={getButtonProps(status)?.isDisabled ? 'none' : 'initial'}
      />
    );
  };

  return (
    <Flex gap={2} py={2} alignItems="center" justifyContent="center">
      {renderSectionIconButton({
        status: section1,
        navigateToURL: '/personal-info/section-start',
        title: 'Go to Personal Information'
      })}
      {renderSectionIconButton({
        status: section2,
        navigateToURL: '/history/section-start',
        title: 'Go to Your History'
      })}
      {renderSectionIconButton({
        status: section3,
        navigateToURL: '/consents/section-start',
        title: 'Go to Consents'
      })}
      {renderSectionIconButton({
        status: section4,
        navigateToURL: '/finances/section-start',
        title: 'Go to Finances'
      })}
    </Flex>
  );
};

export default SectionSummary;
